export default "__VITE_ASSET__HpW5Ga5S__"